module.exports = __webpack_public_path__ + "img/customer-services.300ae18.png";